import {createTheme} from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#DC2040',
      light: '#DC2040'
    },
    warning: {
      main: '#ed6c02'
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 670,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2rem'
    },
    h2: {
      fontWeight: 700,
      fontSize: '1.5rem'
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.25rem'
    },
    h4: {
      fontWeight: 700,
      fontSize: '1rem'
    },
    h5: {
      fontWeight: 700,
      fontSize: '0.9em'
    },
    h6: {
      fontWeight: 700,
      fontSize: '0.8rem'
    }
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#000',
        },
        gutterBottom: {
          marginBottom: '0.5em'
        },
        body2: {
          opacity: 0.7,
          fontWeight: 400,
          fontSize: '1rem'
        },
        subtitle1: {
          lineHeight: 1.5,
        },
        caption: {
          display: 'block',
        }
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        fullWidth: true,
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '0.85rem',
          marginTop: '0.3rem',
          marginLeft: 0,
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: '0.5rem 1.5rem',
        },
        contained: {
          '&:hover, &:focus': {
            color: '#fff',
          },
        },
      },
      defaultProps: {
        variant: 'contained',
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: 'inherit',
          textDecorationColor: 'inherit',
          '&:hover, &:focus': {
            color: '#DC2040',
          }
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#fafafa',
          borderColor: '#e4e4e7',
        },
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 32,
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        secondary: {
          opacity: 0.8,
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: '0.5rem',
          '&.Mui-selected, &:hover': {
            backgroundColor: '#ededed',
          }
        },
      }
    },
    MuiAlert: {
      defaultProps: {
        variant: 'filled',
      },
      styleOverrides: {
        root: {
          textAlign: 'left',
        },
        action: {
          paddingTop: '2px',
        }
      }
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          color: 'inherit'
        }
      }
    }
  }
})

export const globalStyles = {
  a: {
    color: 'inherit',
    textDecoration: 'underline',
    '&:hover, &:focus': {
      color: '#DC2040',
    }
  }
}

export default theme;
